export default "__VITE_ASSET__CADB9Vjh__"